import o from"styled-components";var r=o("div").withConfig({componentId:"sc-1ji1z6r-0"})(["flex:1;box-sizing:border-box;overflow:auto;padding:0 2.4rem;"]);export{r as ContentStyled};
